/**
 * Looks Section
 * Handles both slider mode (Splide) and grid mode (Swiper)
 */

// Store Splide and Swiper instances by section ID
var looksInstances = {};
var looksEventHandlersInitialized = false;

/**
 * Initialize Looks section
 * Can be called multiple times (e.g., theme editor reload)
 */
function initLooks() {
  document.querySelectorAll('.section-looks').forEach((section) => {
    const sectionId = section.classList.toString().match(/section-id-(\S+)/)?.[1];
    const isSliderMode = section.hasAttribute('data-slider-mode');

    if (!sectionId) return;

    // Check if section is already initialized and hasn't changed mode
    const isInitialized = section.getAttribute('data-looks-initialized') === 'true';
    const previousMode = section.getAttribute('data-looks-mode');
    const currentMode = isSliderMode ? 'slider' : 'grid';

    // Skip if already initialized with the same mode
    if (isInitialized && previousMode === currentMode) {
      return;
    }

    // Destroy existing instances before re-initialization
    if (looksInstances[sectionId]) {
      if (looksInstances[sectionId].splide) {
        looksInstances[sectionId].splide.destroy();
      }
      if (looksInstances[sectionId].swipers) {
        looksInstances[sectionId].swipers.forEach(s => s.destroy(true, true));
      }
      looksInstances[sectionId] = null;
    }

    if (isSliderMode) {
      initSliderMode(section, sectionId);
    } else {
      initGridMode(section, sectionId);
    }

    // Mark section as initialized with current mode
    section.setAttribute('data-looks-initialized', 'true');
    section.setAttribute('data-looks-mode', currentMode);
  });

  // Initialize global event handlers only once
  if (!looksEventHandlersInitialized) {
    initGlobalEventHandlers();
    looksEventHandlersInitialized = true;
  }
}

/**
 * Initialize Slider Mode (Splide carousel)
 */
function initSliderMode(section, sectionId) {
  const splideEl = section.querySelector('.splide');
  if (!splideEl) return;

  // Check if there's an existing Splide instance on the element itself and destroy it
  if (splideEl.splide) {
    try {
      splideEl.splide.destroy();
    } catch (e) {
      console.error('Error destroying existing Splide instance:', e);
    }
  }

  // Check if Splide is available, if not wait for it to load
  const initSplideWhenReady = () => {
    if (typeof Splide === 'undefined' || typeof window.splide === 'undefined' || typeof window.splide.Extensions === 'undefined' || typeof window.splide.Extensions.AutoScroll === 'undefined') {
      // Splide or AutoScroll extension not loaded yet, wait and try again
      setTimeout(initSplideWhenReady, 100);
      return;
    }

    try {
      const splideInstance = new Splide(splideEl, {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        perPage: 3.5,
        pagination: false,
        arrows: false,
        autoScroll: {
          speed: 0.5,
          pauseOnHover: false,
        },
      }).mount(window.splide.Extensions);

      // Store instance
      looksInstances[sectionId] = { splide: splideInstance };
    } catch (error) {
      console.error('Error initializing Splide:', error);
    }
  };

  initSplideWhenReady();
}

/**
 * Initialize Grid Mode (Swiper per grid item)
 */
function initGridMode(section, sectionId) {
  const swipers = [];

  section.querySelectorAll('.looks-wrap .looks-inr').forEach((gridItem) => {
    const sliderEl = gridItem.querySelector('.looks-items-slide.swiper');
    if (sliderEl) {
      const swiperInstance = new Swiper(sliderEl, {
        slidesPerView: "auto",
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true,
        },
      });
      swipers.push(swiperInstance);
    }
  });

  // Store instances
  looksInstances[sectionId] = { swipers };
}

/**
 * Initialize global event handlers (only once)
 * Uses event delegation to handle all sections
 */
function initGlobalEventHandlers() {
  // Handle clicks on looks items (both slider and grid modes)
  document.addEventListener('click', function (e) {
    // Slider mode: click on slide to open modal
    let sliderTarget = e.target.closest('.looks-wrap.splide__list .looks-inr');
    if (sliderTarget) {
      e.preventDefault();
      let snippet = sliderTarget.querySelector('.snippet-looks');
      if (snippet) {
        let copy = snippet.cloneNode(true);
        let container = document.querySelector('.look-popup .looks-inr');
        if (container) {
          container.innerHTML = '';
          container.appendChild(copy);
          container.classList.add('active-look');
        }
        document.body.classList.add('open-look');
        setTimeout(function () {
          let sliderEl = document.querySelector('.look-popup .looks-items .looks-items-slide.swiper');
          if (sliderEl) {
            new Swiper(sliderEl, {
              loop: false,
              freeMode: true,
              slidesPerView: "auto",
              mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
              },
            });
          }
        }, 500);
      }
      return;
    }

    // Grid mode: click on image to open modal
    let gridTarget = e.target.closest('.looks-inr:not(.splide__slide) .looks-img');
    if (gridTarget) {
      e.preventDefault();
      document.body.classList.add('open-look');
      let lookInr = gridTarget.closest('.looks-inr');
      lookInr.classList.add('active-look');

      // Re-initialize swipers for this grid item
      lookInr.querySelectorAll('.looks-items-slide.swiper').forEach((sliderEl) => {
        if (sliderEl && !sliderEl.swiper) {
          new Swiper(sliderEl, {
            slidesPerView: "auto",
            mousewheel: {
              forceToAxis: true,
              sensitivity: 1,
              releaseOnEdges: true,
            },
          });
        }
      });
      return;
    }

    // Close modal handlers
    if (e.target.closest('.looks-close') || e.target.closest('.overlay-box')) {
      const container = document.querySelector('.look-popup .looks-inr');
      if (container) {
        container.classList.remove('active-look');
      }
      document.querySelectorAll('.looks-inr.active-look').forEach(item => {
        item.classList.remove('active-look');
      });
      document.body.classList.remove('open-look');
    }
  });

  // Initialize color variant handlers (desktop only)
  if (window.innerWidth > 1024) {
    document.addEventListener('click', function(e) {
      let colorVar = e.target.closest('.grid-bottom .main-color-variant .color-var.click');
      if (colorVar) {
        e.preventDefault();
        const attVal = colorVar.getAttribute('data-id');
        const productItem = colorVar.closest('.looks-mb-item');
        if (!productItem) return;

        const innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
        innerGrids.forEach(function(innerGrid) {
          if (attVal === innerGrid.getAttribute('data-id')) {
            innerGrids.forEach(function(g) {
              g.classList.remove('active');
            });
            innerGrid.classList.add('active');
          }
        });
      }
    });
  }
}


// Initialize on DOM load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLooks);
} else {
  initLooks();
}
